import { z } from 'zod';
export const uuid = z.uuid();
export const code = z
    .string()
    .trim()
    .regex(/^[A-Z0-9][A-Z0-9_-]{1,19}$/, 'Use 2-20 characters: A-Z, 0-9, "-" or "_"');
export const displayName = z.string().trim().min(1).max(120);
export const email = z
    .email()
    .max(254)
    .transform((v) => v.toLowerCase());
export const entityStatus = z.enum(['active', 'inactive']);
export const pageQuery = z.object({
    limit: z.coerce.number().int().min(1).max(200).default(50),
    offset: z.coerce.number().int().min(0).max(100_000).default(0),
});
export function isValidTimeZone(tz) {
    try {
        new Intl.DateTimeFormat('en-US', { timeZone: tz });
        return true;
    }
    catch {
        return false;
    }
}
export const timeZone = z.string().min(1).max(64).refine(isValidTimeZone, 'Unknown IANA time zone');
//# sourceMappingURL=common.js.map